import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

const DATA_FILE_PATH = "/uploads/data.json";
const PLAYABLE_THUMBNAIL_PATH = "/uploads/PlayableThumb/";
const BRAND_ASSET_PATH = "/uploads/Brand/";
const BRAND_LOGO_PATH = "/uploads/Brand/";
const PREV_ARROW_ASSET = "Asset 124.svg";
const NEXT_ARROW_ASSET = "Asset 125.svg";
const BACKGROUND_ASSET = "BG.webp";
const PLACEHOLDER_LOGO = "TRJwf2.tif.svg";

const VerticalDivider = () => (
    <div className="w-px bg-black h-auto self-stretch mx-8"></div>
);

const PlayableHeader = ({ brandName, brandLogo, BrandLogo_new, description, category }) => {
    const brandLogoPath = `${BRAND_LOGO_PATH}${brandLogo}`;
    const brandLogoPath1 = `${BRAND_LOGO_PATH}${BrandLogo_new}`;
    const bgImagePath = `${PLAYABLE_THUMBNAIL_PATH}${BACKGROUND_ASSET}`;
    const placeholderLogoPath = `/images/Playable_final page_assets/${PLACEHOLDER_LOGO}`;

    return (
        <section className="relative w-full overflow-hidden text-white " style={{ background: 'grey' }} >
            {/* <img
                src={bgImagePath}
                alt="Background Graphic"
                className="absolute inset-0 w-full h-full object-cover z-0 pointer-events-none"
            /> */}
            <div className="mx-auto max-w-6xl py-16 px-4 sm:px-6 relative z-10">

                <div className="flex flex-col items-center text-center py-10">

                    <div>
                        <div className="w-40 mx-auto mb-8">
                            <img
                                src={brandName == "Uber" ? brandLogoPath1 : brandLogoPath}
                                alt={`${brandName} Logo`}
                                style={{ width: '200px' }}
                                className="w-100 h-auto object-contain"
                                onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = placeholderLogoPath;
                                }}
                            />
                        </div>

                        <p
                            className="
                                mt-3 text-white max-w-3xl mx-auto
                                font-uber text-base font-normal leading-normal
                            "
                        >
                            {description}
                        </p>
                    </div>

                    <div className="flex justify-center items-stretch mt-12 mx-auto">

                        <div className="text-center px-4">
                            <p className="text-[24px] font-bold mt-1 text-white font-uber font-bold">Client</p>
                            <p className="text-[24px] mt-1 text-white font-uber">{brandName}</p>
                        </div>

                        <VerticalDivider />

                        <div className="text-center px-4">
                            <p className="text-[24px] font-bold mt-1 text-white font-uber font-bold">Category</p>
                            <p className="text-[24px] mt-1 text-white font-uber">{category}</p>
                        </div>

                    </div>

                </div>
            </div>
        </section>
    );
}

const InstructionItem = ({ description, isLast = false }) => (
    <div className="flex relative pl-8 pb-12">
        <div className="absolute left-0 top-0 bottom-0 w-3">
            <div className="absolute top-[14px] w-2 h-2 border-2 border-black rounded-sm"></div>

            {!isLast && (
                <div
                    className="absolute left-[4.5px] top-[25px] w-[1px] bg-black"
                    style={{ height: 'calc(100% - -10px)' }}
                ></div>
            )}
        </div>

        <div className="flex-grow">
            <p
                className="
                    text-gray-900
                    font-uber text-base font-normal leading-normal
                "
            >
                {description}
            </p>
        </div>
    </div>
);

export default function PlayableInstructionsPage() {
    const { playableId } = useParams();
    const navigate = useNavigate();
    const [playable, setPlayable] = useState(null);
    const [brand, setBrand] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const [showIframe, setShowIframe] = useState(false);
    const [currentPlayableIndex, setCurrentPlayableIndex] = useState(-1);
    const [categoryPlayables, setCategoryPlayables] = useState([]);

    useEffect(() => {
        setIsLoading(true);
        setError(null);

        fetch(DATA_FILE_PATH)
            .then(response => {
                if (!response.ok) {
                    throw new Error(`Failed to fetch data: ${response.statusText}`);
                }
                return response.json();
            })
            .then(data => {
                const targetPlayable = data.Playables.find(
                    (p) => p.id === playableId
                );

                if (!targetPlayable) {
                    setError("Playable not found.");
                    return;
                }

                const allPlayablesInCategory = data.Playables.filter(
                    (p) => p.categoryID === targetPlayable.categoryID
                );

                const currentIndex = allPlayablesInCategory.findIndex(p => p.id === playableId);

                const targetBrand = data.Brands.find(
                    (b) => b.brandID === targetPlayable.brandID
                );

                if (!targetBrand) {
                    setError("Brand not found for this playable.");
                    return;
                }

                setPlayable(targetPlayable);
                setBrand(targetBrand);
                setCategoryPlayables(allPlayablesInCategory);
                setCurrentPlayableIndex(currentIndex);
            })
            .catch(err => {
                console.error("Error loading playable data:", err);
                setError("Failed to load playable data.");
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, [playableId]);

    const [reloadKey, setReloadKey] = useState(Date.now());

    const handlePlayClick = (e) => {
        e.preventDefault();
        setReloadKey(Date.now());
        setShowIframe(true);
    };

    const handlePrev = () => {
        if (currentPlayableIndex > 0) {
            const prevPlayable = categoryPlayables[currentPlayableIndex - 1];
            setShowIframe(false);
            navigate(`/playable/${prevPlayable.id}`);
        }
    };

    const handleNext = () => {
        if (currentPlayableIndex < categoryPlayables.length - 1) {
            const nextPlayable = categoryPlayables[currentPlayableIndex + 1];
            setShowIframe(false);
            navigate(`/playable/${nextPlayable.id}`);
        }
    };

    if (isLoading) {
        return <p className="text-center p-20 min-h-screen bg-white">Loading playable details...</p>;
    }

    if (error || !playable || !brand) {
        return <p className="text-center p-20 min-h-screen bg-white text-red-600 text-xl">{error || "Playable or Brand data not available."}</p>;
    }

    const thumbnailPath = `${PLAYABLE_THUMBNAIL_PATH}${playable.thumbnail}`;
    const instructions = Object.values(playable.HowToPlay || {});
    const playableUrl = playable.playableLink;

    const isPrevDisabled = currentPlayableIndex <= 0;
    const isNextDisabled = currentPlayableIndex >= categoryPlayables.length - 1;

    return (
        <>
            <PlayableHeader
                BrandLogo_new={brand.BrandLogo_new}
                brandName={brand.name}
                brandLogo={brand.BrandLogo}
                description={playable.branddescription}
                category={playable.playableCategory}
            />

            <section className="relative w-full overflow-hidden bg-white text-gray-900">
                <div className="mx-auto max-w-6xl py-12 px-4 sm:px-4">

                    <div className="flex flex-col xl-custom:flex-row gap-12 items-center xl-custom:items-start">

                        <div className="w-full xl-custom:w-1/2 order-1 xl-custom:order-1 flex flex-col items-center">

                            <div className="w-full h-auto flex items-center justify-center rounded-lg mb-6  p-4 sm:p-8">
                                {showIframe ? (
                                    // <iframe
                                    //     width={380}
                                    //     height={740}
                                    //     src={`${playableUrl}${playableUrl.includes('?') ? '&' : '?'}t=${reloadKey}`}
                                    //     title={playable.name}
                                    //     className="rounded-lg shadow-xl"
                                    //     allow="gamepad; fullscreen; autoplay"
                                    // ></iframe>
                                    // <iframe
                                    //     width={365}
                                    //     height={720}
                                    //     src={`${playableUrl}${playableUrl.includes('?') ? '&' : '?'}t=${reloadKey}`}
                                    //     title={playable.name}
                                    //     className="rounded-lg shadow-xl"
                                    //     allow="gamepad; fullscreen; autoplay"
                                    // ></iframe>
                                    (() => {
  const matchesCustomSize = 
    playableUrl.includes('testdisnymona') || 
    playableUrl.includes('testbkngtrdgrppct');

  return (
    <iframe
      width={matchesCustomSize ? 365 : 320}
      height={matchesCustomSize ? 720 : 640}
      src={`${playableUrl}${playableUrl.includes('?') ? '&' : '?'}t=${reloadKey}`}
      title={playable.name}
      className="rounded-lg shadow-xl"
      allow="gamepad; fullscreen; autoplay"
    ></iframe>
  );
})()
                                ) : (
                                    <a
                                        href="#"
                                        onClick={handlePlayClick}
                                        className="w-full h-auto cursor-pointer relative block"
                                    >
                                        <img
                                            src={thumbnailPath}
                                            alt={`Play ${playable.name}`}
                                            className="w-full h-auto object-contain rounded-lg shadow-xl"
                                            onError={(e) => {
                                                e.target.onerror = null;
                                                e.target.src = "/placeholder-image.png";
                                            }}
                                        />
                                        <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-30 rounded-lg">
                                            <svg className="w-16 h-16 text-white opacity-90" fill="currentColor" viewBox="0 0 20 20">
                                                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z" clipRule="evenodd" />
                                            </svg>
                                        </div>
                                    </a>
                                )}
                            </div>

                            <div className="flex space-x-4">
                                <button
                                    onClick={handlePrev}
                                    disabled={isPrevDisabled}
                                    className={`
                                        w-10 h-10
                                        transition
                                        flex items-center justify-center
                                        ${isPrevDisabled ? 'opacity-50 cursor-not-allowed' : 'hover:opacity-80'}
                                    `}
                                >
                                    <img src={`${PLAYABLE_THUMBNAIL_PATH}${PREV_ARROW_ASSET}`} alt="Previous" className="w-full h-full" />
                                </button>
                                <button
                                    onClick={handleNext}
                                    disabled={isNextDisabled}
                                    className={`
                                        w-10 h-10
                                        transition
                                        flex items-center justify-center
                                        ${isNextDisabled ? 'opacity-50 cursor-not-allowed' : 'hover:opacity-80'}
                                    `}
                                >
                                    <img src={`${PLAYABLE_THUMBNAIL_PATH}${NEXT_ARROW_ASSET}`} alt="Next" className="w-full h-full" />
                                </button>
                            </div>
                        </div>

                        <div className="w-full xl-custom:w-1/2 order-2 xl-custom:order-2 flex justify-center items-center self-center">

                            <div className="rounded-lg p-8 bg-gray-100 max-w-lg">

                                <h2
                                    className="
                                        w-full text-black mb-6 text-center
                                        font-uber text-[28px] font-bold leading-[36px] text-current
                                        sm:text-[32px] sm:leading-[40px]
                                        xl-custom:text-[36px] xl-custom:leading-[44px]
                                        transition duration-200 ease-in-out
                                    "
                                >
                                    How to play?
                                </h2>

                                <div className="space-y-6">
                                    {instructions.map((instruction, index) => (
                                        <InstructionItem
                                            key={index}
                                            description={instruction}
                                            isLast={index === instructions.length - 1}
                                        />
                                    ))}
                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </section>
        </>
    );
}